import { useQuery } from "@tanstack/react-query"
import { segmentGroupQuery } from "../lib/segmentGroupQuery"

export function useSegmentGroupQuery(...args: Parameters<typeof segmentGroupQuery>) {
  return useQuery(segmentGroupQuery(...args))
}
